import React, { useState, useEffect } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { TabView, TabPanel } from 'primereact/tabview';
import { Card } from 'primereact/card';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Message } from 'primereact/message';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import 'primereact/resources/themes/lara-light-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import { Dialog } from 'primereact/dialog';
import EnquiryModal from './EnquiryModal';
import { confirmDialog } from 'primereact/confirmdialog';
import { InputTextarea } from 'primereact/inputtextarea';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function EnquiryDashboard() {
    const [enquiries, setEnquiries] = useState([]);
    const [loading, setLoading] = useState(false);
    const [activeIndex, setActiveIndex] = useState(0);
    const [error, setError] = useState(null);
    const [totalRecords, setTotalRecords] = useState(0);
    const [currentPage, setCurrentPage] = useState(0);
    const [pageSize] = useState(10);
    const [rejectModal, setRejectModal] = useState();
    const [rejectReason, setRejectReason] = useState('');
    const [rejectRow,setRejectrow] =useState(null);
    // Filter states
    const [filters, setFilters] = useState({
        name: '',
        pincode: '',
        mobile: ''
    });
    const [appliedFilters, setAppliedFilters] = useState({
        name: '',
        pincode: '',
        mobile: ''
    });

    const [showAssignModal, setShowAssignModal] = useState(false);
    const [selectedEnquiry, setSelectedEnquiry] = useState(null);

    // Tab configuration
    const tabs = [
        { label: 'All', status: null, header: 'All Enquiries' },
        { label: 'Assigned', status: 1, header: 'Assigned Enquiries' },
        { label: 'Unassigned', status: 0, header: 'Unassigned Enquiries' },
        { label: 'Reassign', status: 2, header: 'Ressigned Enquiries' },
        { label: 'Order', status: 3, header: 'Ordered Enquiries' },
         { label: 'Cancel', status: 4, header: 'Closed Enquiries' },
    ];

    const fetchEnquiries = async (status = null, page = 0, filterParams = {}) => {
        setLoading(true);
        setError(null);

        console.log('Fetching enquiries - Status:', status, 'Page:', page, 'Filters:', filterParams); // Debug log

        try {
            let url = `${process.env.REACT_APP_PHLEBO_BASEURL}enquiryList?page=${page}&size=${pageSize}`;
            // let url = `phlebo/api/enquiryList?page=${page}&size=${pageSize}`;

            if (status !== null) {
                url += `&status=${status}`;
            }

            // Add filter parameters to URL
            if (filterParams.name && filterParams.name.trim()) {
                url += `&name=${encodeURIComponent(filterParams.name.trim())}`;
            }
            if (filterParams.pincode && filterParams.pincode.trim()) {
                url += `&pincode=${encodeURIComponent(filterParams.pincode.trim())}`;
            }
            if (filterParams.mobile && filterParams.mobile.trim()) {
                url += `&mobile=${encodeURIComponent(filterParams.mobile.trim())}`;
            }

            console.log('API URL:', url); // Debug log

            const response = await fetch(url);
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const apiResponse = await response.json();
            console.log('API Response:', apiResponse); // Debug log

            if (apiResponse.status && apiResponse.data) {
                setEnquiries(apiResponse.data.content || []);
                setTotalRecords(apiResponse.data.totalElements || 0);
                console.log('Data updated - Records:', apiResponse.data.content?.length, 'Total:', apiResponse.data.totalElements, 'Requested Page:', page); // Debug log
            } else {
                throw new Error(apiResponse.message || 'Failed to fetch enquiries');
            }
        } catch (err) {
            setError(`Failed to fetch enquiries: ${err.message}`);
            setEnquiries([]);
            setTotalRecords(0);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const currentTab = tabs[activeIndex];
        setCurrentPage(0);
        fetchEnquiries(currentTab.status, 0, appliedFilters);
    }, [activeIndex, appliedFilters]);

    // Handle page change
    const onPageChange = (event) => {
        console.log('Page change event:', event);
        const newPage = event.page;
        console.log('New page:', newPage);
        setCurrentPage(newPage);
        const currentTab = tabs[activeIndex];
        fetchEnquiries(currentTab.status, newPage, appliedFilters);
    };

    const handleTabChange = (e) => {
        setActiveIndex(e.index);
        // Reset to first page when changing tabs
        setCurrentPage(0);
    };

    // Handle filter input changes
    const handleFilterChange = (field, value) => {
        setFilters(prev => ({
            ...prev,
            [field]: value
        }));
    };

    // Apply filters
    const applyFilters = () => {
        setAppliedFilters({ ...filters });
        setCurrentPage(0); // Reset to first page when applying filters
    };

    // Clear filters
    const clearFilters = () => {
        setFilters({
            name: '',
            pincode: '',
            mobile: ''
        });
        setAppliedFilters({
            name: '',
            pincode: '',
            mobile: ''
        });
        setCurrentPage(0);
    };

    // Check if filters are applied
    const hasActiveFilters = appliedFilters.name || appliedFilters.pincode || appliedFilters.mobile;

    const nameTemplate = (rowData) => {
        const address = rowData.address || 'No address provided';
        const location = [rowData.city, rowData.state, rowData.pincode]
            .filter(Boolean)
            .join(', ');

        return (
            <div style={{ display: 'block' }}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <i className="pi pi-user" style={{ marginRight: '0.5rem' }}></i>
                    <span>{rowData.name || 'N/A'}</span>
                </div>
                <div style={{ marginLeft: '1.5rem', fontSize: '0.875rem', color: '#4b5563', marginTop: '4px' }}>
                    {rowData.mobile || 'N/A'}
                </div>
                <div style={{ marginLeft: '1.5rem', fontSize: '0.875rem', color: '#6b7280', marginTop: '4px' }}>
                    {address}
                </div>
                {location && (
                    <div style={{ marginLeft: '1.5rem', fontSize: '0.8rem', color: '#9ca3af', marginTop: '2px' }}>
                        {location}
                    </div>
                )}
            </div>
        );
    };

    // Template for displaying scheduled date and time
    const scheduledDateTemplate = (rowData) => {
        if (!rowData.scheduleDate) return 'Not scheduled';

        const date = new Date(rowData.scheduleDate);
        const formattedDate = date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
        });

        return (
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <i className="pi pi-calendar" style={{ marginRight: '0.5rem' }}></i>
                <div>
                    <div style={{ fontWeight: '500' }}>{formattedDate}</div>
                    {rowData.scheduleTime && (
                        <div style={{ fontSize: '0.875rem', color: '#6b7280', marginTop: '4px' }}>
                            {rowData.scheduleTime}
                        </div>
                    )}
                </div>
            </div>
        );
    };

    // Template for status badge
    const statusTemplate = (rowData) => {
        const getStatusInfo = (status) => {
            switch (status) {
                case 0: return { label: 'Unassigned', severity: 'warning', icon: 'pi-clock' };
                case 1: return { label: 'Assigned', severity: 'info', icon: 'pi-user-plus' };
                case 2: return { label: 'Reassigned', severity: 'danger', icon: 'pi-times-circle' };
                case 3: return { label: 'Ordered', severity: 'success', icon: 'pi-shopping-cart' };
                 case 4: return { label: 'Cancelled', severity: 'danger', icon: 'pi-times-circle' };
                default: return { label: 'Unknown', severity: 'secondary', icon: 'pi-question-circle' };
            }
        };

        const statusInfo = getStatusInfo(rowData.status);

        return (
            <div style={{
                display: 'inline-flex',
                alignItems: 'center',
                padding: '0.5rem 0.75rem',
                borderRadius: '0.375rem',
                fontSize: '0.875rem',
                fontWeight: '500',
                backgroundColor: statusInfo.severity === 'warning' ? '#fff3cd' :
                    statusInfo.severity === 'info' ? '#d1ecf1' :
                        statusInfo.severity === 'success' ? '#d4edda' :
                            statusInfo.severity === 'danger' ? '#f8d7da' : '#e9ecef',
                color: statusInfo.severity === 'warning' ? '#856404' :
                    statusInfo.severity === 'info' ? '#0c5460' :
                        statusInfo.severity === 'success' ? '#155724' :
                            statusInfo.severity === 'danger' ? '#721c24' : '#6c757d'
            }}>
                <i className={`pi ${statusInfo.icon}`} style={{ marginRight: '0.5rem' }}></i>
                {statusInfo.label}
            </div>
        );
    };

    const currentTab = tabs[activeIndex];
    const [statusCancelled,setStatusCancelled]= useState();

    const actionTemplate = (status,rowData) => {
        setStatusCancelled(status);
        console.log(rowData?.takenPhleboUser?.firstName,"ytgyggy")

        return (
            <div style={{ display: 'block', gap: '0.5rem' }}>
                 {rowData?.takenPhleboUser && <div>Cancelled By: {rowData?.takenPhleboUser?.firstName} {rowData?.takenPhleboUser?.lastName}</div>}
                <button
                    className="p-button p-button-sm p-button-success"
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        padding: '0.5rem 0.75rem',
                        borderRadius: '0.375rem',
                        fontSize: '0.875rem',
                        fontWeight: '500',
                        backgroundColor: '#10b981',
                        color: 'white',
                        border: 'none',
                        cursor: 'pointer',
                        marginTop:'5px'
                    }}
                    onClick={() => handleAssign(rowData)}
                    onMouseOver={(e) => e.target.style.backgroundColor = '#059669'}
                    onMouseOut={(e) => e.target.style.backgroundColor = '#10b981'}
                >
                    <i className="pi pi-user-plus" style={{ marginRight: '0.5rem' }}></i>
                    {status === "cancelled" ? "Reassign":"Assign"}
                </button>
            </div>
        );
    };

    const handleAssign = (rowData) => {
        console.log('Opening assign modal for:', rowData);
        setSelectedEnquiry(rowData);
        setShowAssignModal(true);
    };

    console.log(selectedEnquiry,"ftrtyygy")

    const handleCloseAssignModal = (assignmentSuccess = false) => {
        setShowAssignModal(false);
        setSelectedEnquiry(null);
        
        // Show success toast if assignment was successful
        if (assignmentSuccess) {
            toast.success('Enquiry assigned successfully!', {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            
            // Refresh the enquiry list to show updated data
            const currentTab = tabs[activeIndex];
            fetchEnquiries(currentTab.status, currentPage, appliedFilters);
        }
    };

    // Handle Enter key press in filter inputs
    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            applyFilters();
        }
    };
    
    const rejectTemplate = (rowData) => {
        console.log(rowData,"tftghyh")
        return (
            <>
          
            <Button
                label="Reject"
                icon="pi pi-times"
                severity="danger"
                size="small"
                onClick={() => handleReject(rowData)}
                disabled={rowData.status === 'rejected'}
            />
            </>
        );
    };

    const handleReject = (rowData) => {
         setRejectrow(rowData)
        setRejectModal(true);
    };

    const [message, setMessage] = useState(null);

    const handleRejectEnquiry = async () => {
        try {
            // Clear any existing messages
            setMessage(null);

            // Validate that a reason is provided
            if (!rejectReason.trim()) {
                toast.warn('Please provide a reason for rejection', {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                });
                return;
            }

            const encodedComment = encodeURIComponent(rejectReason.trim());

            const response = await fetch(`${process.env.REACT_APP_PHLEBO_BASEURL}enquiry/reject/${rejectRow?.id}?comment=${encodedComment}&status=4&userId=bo`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                }
            });

            if (response.ok) {
                // Show success toast
                toast.success('Enquiry rejected successfully!', {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });

                // Clear the reject reason and close modal
                setRejectReason('');
                setRejectModal(false);
                
                // Refresh the enquiry list
                const currentTab = tabs[activeIndex];
                fetchEnquiries(currentTab.status, currentPage, appliedFilters);

            } else {
                const errorData = await response.json();
                toast.error(errorData.message || 'Failed to reject enquiry', {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                });
            }
        } catch (error) {
            console.error('Error rejecting enquiry:', error);
            toast.error('Network error occurred while rejecting enquiry', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
        }
    };

    console.log(rejectRow,"tfgtgy")

    return (
     <div >
            <div style={{padding:'10px'}} >
                <h4 style={{
                    fontSize: '1.125rem',
                    fontWeight: '600',
                    color: '#374151',
                    marginBottom: '0.75rem',
                    display: 'flex',
                    alignItems: 'center'
                }}>
                    <i className="pi pi-filter" style={{ marginRight: '0.5rem' }}></i>
                    Filter Enquiries
                    {hasActiveFilters && (
                        <span style={{
                            marginLeft: '0.5rem',
                            padding: '0.25rem 0.5rem',
                            backgroundColor: '#dbeafe',
                            color: '#1e40af',
                            fontSize: '0.75rem',
                            fontWeight: '500',
                            borderRadius: '9999px'
                        }}>
                            Active
                        </span>
                    )}
                </h4>

                <div style={{
                    display: 'grid',
                    gridTemplateColumns: '1fr 150px 150px auto',
                    gap: '1rem',
                    alignItems: 'end'
                }}>
                    <div>
                        <label
                            htmlFor="nameFilter"
                            style={{
                                display: 'block',
                                fontSize: '0.875rem',
                                fontWeight: '500',
                                color: '#374151',
                                marginBottom: '0.5rem'
                            }}
                        >
                            Name
                        </label>
                        <InputText
                            id="nameFilter"
                            value={filters.name}
                            onChange={(e) => handleFilterChange('name', e.target.value)}
                            onKeyPress={handleKeyPress}
                            placeholder="Enter name..."
                            style={{ width: '100%' }}
                        />
                    </div>

                    <div>
                        <label
                            htmlFor="pincodeFilter"
                            style={{
                                display: 'block',
                                fontSize: '0.875rem',
                                fontWeight: '500',
                                color: '#374151',
                                marginBottom: '0.5rem'
                            }}
                        >
                            Pincode
                        </label>
                        <InputText
                            id="pincodeFilter"
                            value={filters.pincode}
                            onChange={(e) => handleFilterChange('pincode', e.target.value)}
                            onKeyPress={handleKeyPress}
                            placeholder="Enter pincode..."
                            style={{ width: '100%' }}
                            keyfilter="pnum"
                            maxLength={6}
                        />
                    </div>

                    <div>
                        <label
                            htmlFor="mobileFilter"
                            style={{
                                display: 'block',
                                fontSize: '0.875rem',
                                fontWeight: '500',
                                color: '#374151',
                                marginBottom: '0.5rem'
                            }}
                        >
                            Mobile
                        </label>
                        <InputText
                            id="mobileFilter"
                            value={filters.mobile}
                            onChange={(e) => handleFilterChange('mobile', e.target.value)}
                            onKeyPress={handleKeyPress}
                            placeholder="Enter mobile number..."
                            style={{ width: '100%' }}
                            keyfilter="pnum"
                            maxLength={10}
                        />
                    </div>

                    <div style={{ display: 'flex', gap: '0.5rem' }}>
                        <Button
                            label="Apply Filters"
                            icon="pi pi-search"
                            onClick={applyFilters}
                            className="p-button-primary"
                            size="small"
                        />
                        <Button
                            label="Clear Filters"
                            icon="pi pi-times"
                            onClick={clearFilters}
                            className="p-button-secondary"
                            size="small"
                            disabled={!hasActiveFilters}
                        />
                    </div>
                </div>
            </div>

            <TabView activeIndex={activeIndex} onTabChange={handleTabChange}>
                {tabs.map((tab, index) => (
                    <TabPanel
                        key={index}
                        header={`${tab.label} `}
                    >
                        <div style={{ marginTop: '1rem' }}>
                            <h3 style={{ fontSize: '1.25rem', fontWeight: '600', marginBottom: '1rem' }}>
                                {tab.header}
                            </h3>

                            {error && (
                                <Message severity="error" text={error} className="mb-4" />
                            )}

                            {loading ? (
                                <div className="flex justify-content-center align-items-center py-8">
                                    <ProgressSpinner style={{ width: '50px', height: '50px' }} />
                                    <span className="ml-3">Loading enquiries...</span>
                                </div>
                            ) : (
                                <DataTable
                                    value={enquiries}
                                    lazy
                                    paginator
                                    rows={pageSize}
                                    totalRecords={totalRecords}
                                    onPage={onPageChange}
                                    first={currentPage * pageSize}
                                    loading={loading}
                                    responsiveLayout="scroll"
                                    emptyMessage={totalRecords === 0 ? (hasActiveFilters ? "No enquiries match your filters" : "No enquiries found") : "Loading..."}
                                    className="p-datatable-striped"
                                    showGridlines
                                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport"
                                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                                    paginatorLeft={<span>Page {currentPage + 1} of {Math.ceil(totalRecords / pageSize) || 1}</span>}
                                >
                                    <Column
                                        field="name"
                                        header="Name / Mobile / Address"
                                        body={nameTemplate}
                                        style={{ minWidth: '280px' }}
                                    />
                                    <Column
                                        field="scheduleDate"
                                        header="Schedule Date / Time"
                                        body={scheduledDateTemplate}
                                        style={{ minWidth: '200px' }}
                                    />
                                    <Column
                                        field="comment"
                                        header="Comment"
                                        style={{ minWidth: '200px' }}
                                    />
                                    <Column
                                        field="status"
                                        header="Status"
                                        body={statusTemplate}
                                        style={{ minWidth: '150px' }}
                                    />
                                     {tab?.label !== "Cancel" && (
                                         <Column
                                             field="orderId"
                                             header="Order Id"
                                             style={{ minWidth: '120px' }}
                                             frozen
                                             alignFrozen="right"
                                         />
                                     )}
                                     {
                                        tab?.label === "Reassign" &&
                                       <Column
                                            header="Action"
                                             body={(rowData) => actionTemplate("cancelled", rowData)}
                                            style={{ minWidth: '120px' }}
                                            frozen
                                            alignFrozen="right"
                                        />
                                    }
                                    {
                                        tab?.label === "Unassigned" &&
                                        <Column
                                            header="Action"
                                              body={(rowData) => actionTemplate("", rowData)}
                                           
                                            style={{ minWidth: '120px' }}
                                            frozen
                                            alignFrozen="right"
                                        />
                                    }
                                    {
                                        tab?.label === "Unassigned" &&
                                        <Column
                                            header="Reject"
                                            body={rejectTemplate}
                                            style={{ minWidth: '120px' }}
                                            frozen
                                            alignFrozen="right"
                                        />
                                    }
                                </DataTable>
                            )}
                        </div>
                    </TabPanel>
                ))}
            </TabView>

            {
                showAssignModal &&
                <EnquiryModal 
                    selectedEnquiry={selectedEnquiry} 
                    handleCloseAssignModal={handleCloseAssignModal} 
                    statusCancelled={statusCancelled}
                />
            }

            {/* Modal dialog for rejecting enquiry with confirmation */}
         <>
            <style jsx>{`
                .dialog-footer {
                    display: flex;
                    justify-content: flex-end;
                    gap: 12px;
                    padding: 16px 0 0 0;
                }

                .dialog-content {
                    padding: 24px;
                }

                .form-field {
                    display: block;
                    margin-bottom: 16px;
                }

                .field-label {
                    display: block;
                    margin-bottom: 8px;
                    font-weight: 500;
                    font-size: 14px;
                    color: #374151;
                }

                .required-asterisk {
                    color: #ef4444;
                }

                .textarea-container {
                    width: 100%;
                }

                .reject-textarea {
                    width: 100%;
                    min-height: 100px;
                    padding: 12px;
                    border: 1px solid #d1d5db;
                    border-radius: 6px;
                    font-family: inherit;
                    font-size: 14px;
                    line-height: 1.5;
                    resize: vertical;
                }

                .reject-textarea:focus {
                    outline: none;
                    border-color: #2563eb;
                    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
                }

                .reject-textarea::placeholder {
                    color: #9ca3af;
                }

                .button-cancel {
                    background: transparent;
                    border: 1px solid #d1d5db;
                    color: #374151;
                    padding: 8px 16px;
                    border-radius: 6px;
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    gap: 6px;
                    font-size: 14px;
                }

                .button-cancel:hover {
                    background-color: #f9fafb;
                    border-color: #9ca3af;
                }

                .button-reject {
                    background-color: #dc2626;
                    border: 1px solid #dc2626;
                    color: white;
                    padding: 8px 16px;
                    border-radius: 6px;
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    gap: 6px;
                    font-size: 14px;
                }

                .button-reject:hover {
                    background-color: #b91c1c;
                    border-color: #b91c1c;
                }
            `}</style>

            <Dialog
                header="Reject Enquiry Details"
                visible={rejectModal}
                onHide={() => setRejectModal(false)}
                style={{ width: '700px', maxWidth: '90vw' }}
                modal
                draggable={false}
                resizable={false}
                footer={
                    <div className="dialog-footer">
                        <button
                            type="button"
                            onClick={() => setRejectModal(false)}
                            className="button-cancel"
                        >
                            <i className="pi pi-times"></i>
                            Cancel
                        </button>
                        <button
                            type="button"
                            onClick={handleRejectEnquiry}
                            className="button-reject"
                        >
                            <i className="pi pi-ban"></i>
                            Reject
                        </button>
                    </div>
                }
            >
                <div className="dialog-content">
                    <div className="form-field">
                        <label htmlFor="rejectReason" className="field-label">
                            Reason for Rejection <span className="required-asterisk">*</span>
                        </label>
                        <div className="textarea-container">
                            <textarea
                                id="rejectReason"
                                value={rejectReason}
                                onChange={(e) => setRejectReason(e.target.value)}
                                rows={4}
                                placeholder="Please provide a reason for rejecting this enquiry..."
                                className="reject-textarea"
                            />
                        </div>
                    </div>
                </div>
            </Dialog>
        </>

        {/* Toast Container */}
        <ToastContainer
            position="top-right"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
        />

        </div>
    );
}

export default EnquiryDashboard;